export default __webpack_public_path__ + "static/media/Thalamus_Logo.b64d7aa4.svg";